<app-side-menu>
  <div class="portal-user-form-content">
    <div class="page-header">
      <button class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
      <div>
        <h1 class="page-title">{{ isEditMode ? 'Editar usuário do portal' : 'Novo usuário do portal' }}</h1>
        <p class="page-subtitle" *ngIf="contractNumber">Contrato: {{ contractNumber }} - {{ contractName }}</p>
      </div>
    </div>

    <div class="form-card" *ngIf="!isLoading; else loadingTpl">
      <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-grid">
          <div class="field">
            <label>Nome *</label>
            <input type="text" formControlName="name" class="form-control" />
          </div>
          <div class="field">
            <label>E-mail *</label>
            <input type="email" formControlName="email" class="form-control" />
          </div>
          <div class="field">
            <label>{{ isEditMode ? 'Nova senha (opcional)' : 'Senha *' }}</label>
            <input type="password" formControlName="password" class="form-control" autocomplete="new-password" />
          </div>
          <div class="field">
            <label>Perfil *</label>
            <select formControlName="roleCode" class="form-control" [disabled]="isLoadingRoles || !roles.length">
              <option value="" disabled>Nenhum perfil disponível</option>
              <option *ngFor="let role of roles" [value]="role.code">{{ role.name }} ({{ role.code }})</option>
            </select>
            <small class="field-hint" *ngIf="isLoadingRoles">Carregando perfis...</small>
            <small class="field-error" *ngIf="rolesError">{{ rolesError }}</small>
            <button type="button" class="btn-link" *ngIf="!isLoadingRoles" (click)="loadRoles()">
              Recarregar perfis
            </button>
          </div>
          <div class="field checkbox" *ngIf="isEditMode">
            <label>
              <input type="checkbox" formControlName="active" />
              Usuário ativo
            </label>
          </div>
        </div>

        <div class="actions">
          <button type="button" class="btn-secondary" (click)="navigateBack()">Cancelar</button>
          <button type="submit" class="btn-primary" [disabled]="isSubmitting">
            {{ isSubmitting ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </form>
    </div>
    <ng-template #loadingTpl>
      <div class="empty-state"><i class="fas fa-spinner fa-spin"></i><p>Carregando...</p></div>
    </ng-template>
  </div>
</app-side-menu>
